// Enum to toggle the text of the warning modal, for failure
// to save a draft in the kernel editor, based on the error type.
export enum FailureType {
  CONNECTION,
  SERVER,
  CONCURRENCY,
  FILESIZE,
}
